import { makeStyles } from '@material-ui/core';
import { purple } from 'globals/colors';

export const useStyles = makeStyles(() => ({
  selectedTextClass: {
    color: purple.BRAND,
    fontWeight: 600,
  },
  selectedClass: {
    backgroundColor: purple.V4,
  },
}));

export default {
  useStyles,
};
